import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {
  faBarsStaggered,
  faLayerGroup,
  faLink,
  faPeopleGroup,
} from '@fortawesome/free-solid-svg-icons';

export interface Tab {
  value: string;
  label: string;
}

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit {
  @Input() tabs: Tab[];
  @Input() activeTab: Tab;
  @Output() onTabChange = new EventEmitter<Tab>();

  streamIcon = faBarsStaggered;
  linksIcon = faLink;
  linkedIcon = faPeopleGroup;
  sourcesIcon = faLayerGroup;

  constructor() {}

  ngOnInit() {}

  getIcon(item: Tab) {
    switch (item.value) {
      case 'news':
        return this.streamIcon;
      case 'linked':
        return this.linkedIcon;
      case 'sources':
        return this.sourcesIcon;
      default:
        return this.linksIcon;
    }
  }
}
